// src/components/navigation/NavBar.tsx

import React from "react";

import { useNavigation } from "../../hooks/useNavigation";

import { DesktopSidebar } from "./DesktopSidebar";
import { MobileTopBar } from "./MobileTopBar";
import { MobileBottomNav } from "./MobileBottomNav";
import { ErrorBanner } from "./ErrorBanner";

export const NavBar: React.FC = () => {
  const {
    navItems,
    mobileNavItems,
    isLoggingOut,
    error,
    notifications,
    unreadCount,
    userDisplayInfo,
    isAuthenticated,
    user,
    location,
    handleNavigation,
    handleLogout,
    handleNotificationClick,
    handleMarkAllAsRead,
    isActive,
    clearError,
    navigate,
  } = useNavigation();

  if (!isAuthenticated || !user) {
    return null;
  }

  const handleViewAllNotifications = () => {
    navigate("/notifications");
  };

  return (
    <>
      {error && (
        <ErrorBanner
          message={error}
          onDismiss={clearError}
        />
      )}

      <DesktopSidebar
        navItems={navItems}
        notifications={notifications}
        unreadCount={unreadCount}
        userDisplayInfo={userDisplayInfo}
        currentPath={location.pathname}
        isActive={isActive}
        onNavigate={handleNavigation}
        onNotificationClick={handleNotificationClick}
        onMarkAllAsRead={handleMarkAllAsRead}
        onViewAllNotifications={handleViewAllNotifications}
      />

      <MobileTopBar
        notifications={notifications}
        unreadCount={unreadCount}
        userDisplayInfo={userDisplayInfo}
        isLoggingOut={isLoggingOut}
        onNavigate={handleNavigation}
        onLogout={handleLogout}
        onNotificationClick={handleNotificationClick}
        onMarkAllAsRead={handleMarkAllAsRead}
        onViewAllNotifications={handleViewAllNotifications}
      />

      <MobileBottomNav
        navItems={mobileNavItems}
        isActive={isActive}
        onNavigate={handleNavigation}
      />

      <div
        className="h-14 md:hidden"
        aria-hidden="true"
      />
    </>
  );
};

export default NavBar;